module.exports = __webpack_public_path__ + "img/qilin-f-stage5-sulking.77918ba4.png";